import React, {useRef} from "react";
import {findDOMNode} from "react-dom";
import Classes from "classnames";
import Popover from "../../../../gd-components/gd-popover/popover";
import {FieldPopoverProps} from "../../../proto/types";
import AttachmentsManager from "../../../../gd-components/files/attachments-manager/attachments-manager";
import {AttachFileMode} from "../../../../gd-components/files/const";
import AttachmentsCollection from "../../../../model2/attachment/attachments";

export default function FieldAttachments_Popover(props:FieldPopoverProps) {

    const attachmentsRef = useRef<any>(null);

    return (
        <Popover attachment="top center"
                 targetAttachment="bottom center"
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>
            <div className={Classes("ui5-popover-selector", "cards-selector", "p-10")}>
                <AttachmentsManager  ref={attachmentsRef}
                                     mode={AttachFileMode.VIEW}
                                     className="m-l-15 m-t-10"
                                     attachmentsCollection={new AttachmentsCollection(props.model.attachments)}/>
            </div>
        </Popover>
    )
}
